import TipDialog from "./TipDialog.vue";
export default {
  components: {
    TipDialog
  },
  props: {
    menuList: Array,
    zhsRole: Number,
    // 角色
    onlineLink: String // 在线学堂链接

  },

  data() {
    return {
      showDialog: false
    };
  },

  methods: {
    handleLink(url) {
      if (url) {
        window.open(url);
      } else {
        this.showDialog = true;
      }
    }

  }
};